import { useEffect } from 'react';
import i18n from '@translations/i18n';
import { CurrentUser } from '@api/memberApi/interfaces';

export const useSyncMemberLocale = (currentUser: CurrentUser | null): void => {
  useEffect(() => {
    if (!currentUser?.member.locale) {
      return;
    }

    const preferredLocale = currentUser.member.locale;

    if (i18n.language !== preferredLocale) {
      void i18n.changeLanguage(preferredLocale);
    }
  }, [currentUser?.member.locale]);
};
